import { memo, useEffect, useState, useContext, useRef } from 'react';
import { useTranslation } from "react-i18next";

import './css/Login.css'
import manSrc from '../../images/moe.png'

import { AppContext } from "../../Context";
import Popups from "../../components/Popups";
import { Input } from "../../components/Form";

import Fetch, { Loader, dateToText } from "../../inc/Fetch";


export default memo(function Login({setopen, open}) {

    const { t } = useTranslation();
    const active = useRef(true);
    const {success, userinfo, languageText} = useContext(AppContext);
    const [suc, setsuc] = success;
    const [logedIn, setlogedIn] = userinfo;
	const [text, settext] = languageText;

	const [access, setaccess] = useState(false);

    const [values, setvalues] = useState({});
    const [loader, setloader] = useState(false);


    function submit(e) {
        e.preventDefault();
        setloader(true);

        Fetch("login", (d) => {

            if (d?.error) {
                if (d?.error?.captcha) {
                    console.log("captcha");
                } else {
                    setsuc({

                        short:t("error",  { returnObjects: true })[d?.error],
                        error:true
                    });
                }
                
            } else {  
                
                setsuc({
                    // title:text?.alertSuccessTitle,
                    short:"تم تسجيل الدخول بنجاح.",
                    error:false
                });
                setTimeout(() => {
                    setopen(false);
                    setlogedIn(d);
                }, 2500);
                
            }

            setloader(false);
        }, values);

    }


    return (

        <Popups setOpen={setopen} style={{maxWidth:400, borderTop:"4px solid #fd745a"}}>
            {loader && <Loader />}
           <>

                <div className='popupBody interface data' >

                    <form onSubmit={submit} className='loginForm'>
                        <h2>تسجيل الدخول</h2>
                        <p>مرحبا بكم في موقعنا قم بتسجيل الدخول للتمتع بكافة مزايا الموقع.</p>

                            <Input 
                                title={"اسم المستخدم"} 
                                name="user"
                                type="text"
                                autoFocus={true}
                                // validate={true}
                                onChange={(v) => setvalues(p => ({
                                    ...p,
                                    user:v,
                                }))}
                            />

                            <Input 
                                title="كلمة المرور"
                                name="pass"
                                type="password"
                                // validate={true}
                                onChange={(v) => setvalues(p => ({
                                    ...p,
                                    pass:v,
                                }))}
                            />

                            {/* <object>
                                <embed src="/static/filename.svg" />
                            </object> */}

                            <button role="button" aria-haspopup="true" className='btn'>ادخل الآن</button>

                            <div className='or'>
                                <span>او عن طريق</span>
                            </div>

                            <a className='btn extLogin' href=''><img src={manSrc} />وزارة المعارف </a>
                        
                    </form>

                    
                </div>
            </> 

            

        </Popups>
        
    );
})